import moment from 'moment'

export function responseData (response) {
  if (!response || response.success === false || !['200', '000000'].includes(String(response.code))) throw new Error((response && response.message) || '请求失败')
  return response.data
}

export const clone = value => JSON.parse(JSON.stringify(value))
export const errorText = error => typeof error === 'string' ? error : (error && error.message) || '请求失败，请重试'
export const hasCycle = value => value !== null && value !== undefined && !['', '-', '—'].includes(String(value))
export const periodText = value => !hasCycle(value) ? '—' : /^\d+(\.\d+)?$/.test(String(value)) ? `${value}天` : String(value)
export function packageText (row) {
  if (row.exceptionCode === 'NOT_SHELF' || row.lifeCycleType === 'NOT_SHELF') return '不计算'
  if (hasCycle(row.regularDeliveryCycle)) return periodText(row.regularDeliveryCycle)
  return [hasCycle(row.expressDeliveryCycle) ? `快递 ${periodText(row.expressDeliveryCycle)}` : '', hasCycle(row.logisticsDeliveryCycle) ? `物流 ${periodText(row.logisticsDeliveryCycle)}` : ''].filter(Boolean).join(' / ') || '—'
}
export const newShelfText = row => row.classCode === 'NEW_SHELF' ? '是' : row.classCode ? '否' : '—'
export function sortRuleRows (rows = []) {
  const order = row => {
    const value = row.priorityValue
    if (value !== null && value !== undefined && value !== '' && Number.isFinite(Number(value))) return Number(value)
    const match = /^P(\d+)$/.exec(row.priorityCode || '')
    return match ? Number(match[1]) : Number.POSITIVE_INFINITY
  }
  return rows.map((row, index) => ({ row, index, priority: order(row) }))
    .sort((left, right) => left.priority - right.priority || left.index - right.index)
    .map(item => item.row)
}
export function options (items = []) {
  return (items || []).map(item => typeof item !== 'object' ? { value: item, label: String(item) } : { value: item.classCode == null ? item.code : item.classCode, label: item.className || item.name || String(item.classCode == null ? item.code : item.classCode) })
}
export const pageRequest = (pageNum, pageSize, filterData) => ({ pageNum, pageSize, filterData: Object.fromEntries(Object.entries(filterData).filter(([, value]) => value !== '' && value != null && !(Array.isArray(value) && !value.length))) })
export function queryFilter (type, form) {
  if (!form.dataDate || !/^([01]\d|2[0-3]):[0-5]\d$/.test(form.timeVersion || '')) throw new Error('请选择数据日期和时间版本')
  const filter = { dataDate: form.dataDate, timeVersion: form.timeVersion }
  const keys = type === 'package' ? ['packCode', 'packName', 'lifeCycleType', 'productionLogisticsType', 'supplyChannel', 'deliveryCycle', 'sevenDayFlag'] : ['skuCode', 'skuName']
  keys.forEach(key => { if (form[key] !== '' && form[key] != null) filter[key] = key === 'deliveryCycle' ? Number(form[key]) : form[key] })
  return filter
}
export function validateFixed (row) {
  if (!row.skuCode || !row.skuName) {
    return '请查询并确认有效的商品编码（SKU）'
  }

  if (!/^[1-9]\d*$/.test(String(row.fixedDeliveryCycle)) ||
    !Number.isSafeInteger(Number(row.fixedDeliveryCycle))) {
    return '固定发货周期必须为正整数'
  }

  if (!moment(row.effectiveStartDate, 'YYYY-MM-DD', true).isValid()) {
    return '请选择有效的生效开始日期'
  }

  if (!row.longTermEffective && !moment(row.effectiveEndDate, 'YYYY-MM-DD', true).isValid()) {
    return '请选择有效的生效结束日期'
  }

  if (!row.longTermEffective && row.effectiveEndDate < row.effectiveStartDate) {
    return '结束日期不得早于开始日期'
  }

  return ''
}
export function dateInputValue (value) {
  if (value == null || value === '') return ''
  const text = String(value)
  if (/^\d{4}-\d{2}-\d{2}/.test(text)) return text.slice(0, 10)
  const parsed = moment(value)
  return parsed.isValid() ? parsed.format('YYYY-MM-DD') : ''
}
export function fixedForm (row) {
  const longTermEffective = Number(row.longTermEffective) === 1 || String(row.effectiveEndDate || '').startsWith('9999-12-31')
  return { ...clone(row), effectiveStartDate: dateInputValue(row.effectiveStartDate), effectiveEndDate: longTermEffective ? '' : dateInputValue(row.effectiveEndDate), longTermEffective }
}
export function fixedDateText (row, key) {
  if (key === 'effectiveEndDate' && (Number(row.longTermEffective) === 1 || String(row.effectiveEndDate || '').startsWith('9999-12-31'))) return '长期'
  return dateInputValue(row[key]) || '—'
}
export function fixedPayload (row) {
  return { ...(row.id ? { id: row.id } : {}), skuCode: row.skuCode, fixedDeliveryCycle: Number(row.fixedDeliveryCycle), effectiveStartDate: `${row.effectiveStartDate}T00:00:00`, ...(!row.longTermEffective ? { effectiveEndDate: `${row.effectiveEndDate}T00:00:00` } : {}), longTermEffective: !!row.longTermEffective }
}
export function rulePayload (row) {
  return { ...(row.ruleId ? { ruleId: row.ruleId } : {}), ...(row.configType ? { configType: row.configType } : {}), classCode: row.classCode, productionLogisticsType: row.productionLogisticsType, priorityCode: row.priorityCode, supplyChannels: row.supplyChannels, nodes: (row.nodes || []).map((node, index) => ({ ...(node.nodeId ? { nodeId: node.nodeId } : {}), nodeSeq: index + 1, fieldCode: node.fieldCode, judgmentSymbol: node.judgmentSymbol, judgmentValue: node.judgmentValue, unit: node.unit, ...(index ? { logicConnector: node.logicConnector || 'AND' } : {}) })), resultType: row.resultType, ...(row.resultType === 'FIXED' ? { resultValue: row.resultValue } : { resultSourceField: row.resultSourceField }) }
}
export function buildImportTask (reportName, appCode, paramMap = {}) {
  return { reportName, appCode, paramMap: Object.entries(paramMap).map(([fieldName, fieldValue]) => ({ columnName: fieldName, columnValue: fieldValue, fieldName, fieldValue, relation: fieldName })) }
}
export function detailParams (row, type) {
  if (!row.versionNo) throw new Error('本条数据未返回计算版本号，暂时无法加载计算明细')
  return { versionNo: row.versionNo, [type === 'package' ? 'packCode' : 'skuCode']: type === 'package' ? row.packCode : row.skuCode, ...(row.configType ? { configType: row.configType } : {}) }
}
